import api from "../apis/TeachersApi";
import * as constants from "../constants/SpeakerConstant"

export const SpeakerProfile = (data, onSuccess, onError) => (dispatch) => {
  api
    .Speakers()
    .speakerProfile(data)
    .then((res) => {
      onSuccess(res.data);
    })
    .catch((err) => {
      if (err.code === 'ECONNABORTED'){
        onError("Timeout");
      }else{
      console.log(err.response);
      onError(err.response.data.message);
      }
    });
};

export const AddFavoriteSpeakers = (speakerId,speakerData, onSuccess, onError) => (dispatch) => {
  api
    .Speakers()
    .addFavoriteSpeaker(speakerId)
    .then((res) => {
      console.log(res.data)
      onSuccess(res.data.message);
      dispatch({
        type:constants.ADD_FAVORITE_SPEAKER,
        payload:speakerData
      })
    })
    .catch((err) => {
      if (err.code === 'ECONNABORTED'){
        onError("Timeout");
      }else{
      console.log(err.response);
      onError(err.response.data.message);
      }
    });
};

export const GetFavoriteSpeakers = () => (dispatch) => {
  api
    .Speakers()
    .getFavoriteSpeakers()
    .then((res) => {
    
      dispatch({
        type:constants.GET_FAVORITE_SPEAKERS,
        payload:res.data.favSpeakers
      })
    })
    .catch((err) => {
      if (err.code === 'ECONNABORTED'){
        console.log("Timeout");
      }else{
      console.log(err);
      }
    });
};

export const RemoveFavoriteSpeakers = (data,onSuccess,onError) => (dispatch) => {
  api
    .Speakers()
    .removeFavoriteSpeaker(data)
    .then((res) => {
      onSuccess(res.data.message)
      dispatch({
        type:constants.REMOVE_FAVORITE_SPEAKER,
        payload:data.speakerId
      })
    })
    .catch((err) => {
      if (err.code === 'ECONNABORTED'){
        onError("Timeout");
      }else{
      console.log(err.response);
      onError(err.response.data.message);
      }
    });
};
